module.exports = __webpack_public_path__ + "img/min-comp-bg.ca13c75e.svg";